import { defineMessages } from 'react-intl';

export default defineMessages({
risInf1:{
id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Risk Information',
defaultMessage: 'Risk Information'
},
busInf2:{
id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Business Information',
defaultMessage: 'Business Information'
},
comStr3:{
id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Company Structure',
defaultMessage: 'Company Structure'
},
canRegCom4:{
id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Canadian Registered Company?',
defaultMessage: 'Canadian Registered Company?'
},
web5:{
id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Website',
defaultMessage: 'Website'
},
indCat6:{
id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Industry Category',
defaultMessage: 'Industry Category'
},
indDes7:{
id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Industry Description',
defaultMessage: 'Industry Description'
},
doeTheBuiNeeAirCon8:{
id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Does the building need Air Condition?',
defaultMessage: 'Does the building need Air Condition?'
},
doYouReqSerIntCov9:{
id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Do you require service interruption coverage?',
defaultMessage: 'Do you require service interruption coverage?'
},
doYouReqOffSerCov10:{
id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Do you require office services coverage?',
defaultMessage: 'Do you require office services coverage?'
},
havTheBeeAnyChaInOpe11:{
id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Have there been any changes in operations?',
defaultMessage: 'Have there been any changes in operations?'
},
ifYesPleDes12:{
id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.If yes, please Describe:',
defaultMessage: 'If yes, please Describe:'
}, 
searchCategory: {
    id: 'quoteandbind.PCTLinedirectives.templates.RiskInformation.searchCategory',
    defaultMessage: 'Search Industry Category'
},
clearCategory: {
    id: 'quoteandbind.PCTLinedirectives.templates.RiskInformation.clearCategory',
    defaultMessage: 'Clear the selected Industry Category'
},
industryCodeSearch: {
    id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Industry Code Search',
    defaultMessage: 'Industry Code Search'
},
Code: {
    id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Code',
    defaultMessage: 'Code'
},
search: {
    id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Search',
    defaultMessage: 'Search'
},
reset: {
    id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Reset',
    defaultMessage: 'Reset'
},
cancel: {
    id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Cancel',
    defaultMessage: 'Cancel'
},
searchResults: {
    id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Search Results',
    defaultMessage: 'Search Results'
},
select: {
    id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Select',
    defaultMessage: 'Select'
},
industryCode: {
    id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Industry Code',
    defaultMessage: 'Industry Code'
},
descriptionOfOccupancy: {
    id: 'quoteandbind.PPLProLinedirectives.templates.RiskInformation.Description Of Occupancy',
    defaultMessage: 'Description Of Occupancy'
}


});